import { OrderStatusGroup } from '@tcr-erp/shared';
import { resolveOrderStatusGroupTextColor } from './constants';

/**
 * Build nhãn 1 tab trạng thái: chữ đậm, màu theo trạng thái + badge số cùng màu.
 * count = 0 vẫn giữ màu gốc (không làm mờ), chỉ ẩn badge — TCR-2457: làm mờ xám
 * khiến tab rỗng trông như bị disable. Mirror ECom Orders (`ECom/orders/parts/tab-label.tsx`).
 */
export function buildOrderStatusTabLabel(
  group: OrderStatusGroup,
  label: string,
  count: number,
): React.ReactNode {
  const textColor = resolveOrderStatusGroupTextColor(group) || undefined;
  const badgeColor = resolveOrderStatusGroupTextColor(group) || '#767676';

  return (
    <span style={{ color: textColor, fontWeight: 600 }}>
      {label}
      {count > 0 && (
        <span
          style={{
            marginLeft: 4,
            background: badgeColor,
            color: '#fff',
            borderRadius: 10,
            padding: '0 6px',
            fontSize: 11,
            fontWeight: 600,
          }}
        >
          {count}
        </span>
      )}
    </span>
  );
}
